const merge = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 12.837c-.703 1.028-1.743 1.673-2.909 1.673H.25v-1.98h4.841c1.037 0 1.977-1.24 1.977-2.85V2.25h1.864v7.43c0 1.61.94 2.85 1.977 2.85h4.841v1.98h-4.84c-1.167 0-2.207-.645-2.91-1.673"/><polygon points="4.5 3.8 8 0.3 11.5 3.8" transform="translate(8.000000, 2.050000) scale(-1, 1) translate(-8.000000, -2.050000)"/></svg>',
};

export { merge as default };
